import { z } from "zod";

export const RuleFormSchema = z.object({
  plant: z
    .string()
    .min(1, "Please select a plant"),

  workCenter: z
    .string()
    .min(1, "Please select a work center"),

  materialCategory: z
    .string()
    .min(1, "Please select a material category"),

  approvalLevel: z
    .string()
    .min(1, "Please select an approval level")
    .refine((val) => ["1", "2", "3"].includes(val), "Invalid approval level"),
});

// Type inference
export type RuleFormSchemaType = z.infer<typeof RuleFormSchema>;
